export default (state = {}) => {
  return {
    ...state,
    allProfiles: {},
    coachCompetencies: {},
    rankProgressions: {},
    rankProgressionDetailVisibilities: {},
    allPerformances: {},
    allTeams: {},
    allEarnings: {},
    CABBanner: {},
    acceleratorBonusBanner: {},
    CSBPlusBanner: {},
    incentiveTripBonusBanner: {},
    sameDayLastMonth: {},
    bonuses: [],
    Edge365: {},
    businessProfile: {},
    socialMedia: {},
    healthcare: {},
    leadsPool: {},
    supportedLanguages: {},
    businessProfileImage: {},
  };
};
